// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"SectionPlanModal_subtitle__12YCF","headline":"SectionPlanModal_headline__dCUEV","field":"SectionPlanModal_field__20h78"};